import XLSX from 'xlsx-js-style';

/**
 * Excel 생성 유틸
 *
 * @param {Object} options
 * @param {string} options.sheetName - 시트명
 * @param {Array}  options.columns   - 컬럼 정의 배열
 *    - key: rows(=tableData) 각 객체의 속성과 정확히 매핑되어야 함
 *    - label: Excel 헤더로 표시될 컬럼명
 * @param {Array}  options.rows      - 실제 데이터 배열 (row[key] 방식으로 매핑됨)
 * @param {string} options.fileName  - 다운로드 파일명
 * @param {Object} options.headerStyle - 헤더 스타일 (선택)
 */
export default function createExcelFile({
  sheetName = 'Sheet1',
  columns = [],
  rows = [],
  fileName = 'esign.xlsx',
  headerStyle = {
    font: { bold: true },
    alignment: { horizontal: 'center', vertical: 'center' },
    fill: { fgColor: { rgb: 'E0E6F2' } },
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
}) {
  // v : 셀에 들어갈 값
  // t : 셀의 타입(s의 경우 문자열)을 지정
  // s : 스타일을 지정

  // 새로운 workbook을 만든다
  const wb = XLSX.utils.book_new();

  // header 생성
  const headerRow = columns.map((col) => ({
    v: col.label,
    s: headerStyle,
  }));

  /**
   * 데이터 처리 rows
   * - key: tableData(= rows)의 객체 속성과 정확히 매핑되어야 함 *
   * - label: 엑셀 시트에 표시될 컬럼명
   */
  const dataRows = rows.map((row) =>
    columns.map((col) => ({
      v: row[col.key] ?? '',
      s: {}, // 필요 시 스타일 확장 가능
    })),
  );

  // 시트 생성
  const ws = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);

  // Workbook에 Sheet 추가
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // 바이너리 생성
  const excelBuffer = XLSX.write(wb, {
    bookType: 'xlsx',
    type: 'array',
  });

  // 다운로드 처리
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
